<div class="logout-dialog-container">
  <!-- Top Icon Badge -->
  <div class="logout-icon-badge">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#dc2626" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
      <polyline points="16 17 21 12 16 7"></polyline>
      <line x1="21" y1="12" x2="9" y2="12"></line>
    </svg>
  </div>

  <!-- Header Text -->
  <h3 class="logout-title">Log out of Apptunix?</h3>
  <p class="logout-subtitle">You'll need to sign in again to get back to your dashboard.</p>

  <!-- Profile Card -->
  <div class="profile-card">
    <div class="profile-avatar">
      {{ userInitials }}
    </div>
    <div class="profile-details">
      <span class="profile-name">{{ userName }}</span>
      <span class="profile-email">{{ userEmail }}</span>
    </div>
  </div>

  <!-- Action Buttons -->
  <div class="dialog-actions">
    <button type="button" class="btn-cancel" (click)="cancel()">
      Stay signed in
    </button>
    <button type="button" class="btn-logout" (click)="confirmLogout()">
      Log out
    </button>
  </div>
</div>

